export interface Event {
  [key: string]: any
  product?: string
  event: string
}

export interface Product {
  item_name: string
  item_id: number
  price: number
  item_category: string
  quantity: number
}

export interface EcommerceEvent {
  event: string
  ecommerce: {
    [key: string]: any
  }
  eventParams?: Record<string, string | number | boolean | undefined>
}

export enum PortalProducts {
  ACCOUNT = 'account',
  ACTIVITIES = 'activities',
  AVATAR = 'avatar',
  AVATAR_TUTORIAL = 'avatar_tour',
  CAMPAIGN = 'campaign',
  CHAT = 'chat',
  CHECKLIST = 'checklist',
  CURRICULUM = 'curriculum',
  DASHBOARD = 'dashboard',
  ENCYCLOPEDIA = 'encyclopedia',
  EXPERIMENT = 'gb_experiment',
  HOMEBASE = 'home_base',
  INFRASTRUCTURE = 'infrastructure',
  LEARNING_PATH = 'learning_path',
  LEARNING_PATH_TOUR = 'learning_path_tour',
  LEARNING_TRACK = 'learning_track',
  MATHVAULT = 'math_vault',
  MATH_ESSENTIALS = 'math_essentials',
  MATH_TOPICS = 'math_topics',
  MULTIPLICATION_MASTER = 'multiplication_master',
  NAVIGATION = 'navigation',
  NEWSLETTER = 'newsletter',
  NOTIFICATION = 'notification',
  ONBOARDING = 'onboarding',
  PRE_SIGNUP_FLOW = 'pre_signup_flow',
  TEST_PREP = 'test_prep',
  ORACLE = 'oracle',
  PLAYCANVAS = 'playcanvas',
  QUEST = 'quest',
  SCOREBOARD = 'scoreboard',
  SEARCH = 'search',
  SHOP = 'shop',
  STACK_N_LOAD = 'stack_n_load',
  STUDENT_PANEL = 'student_panel',
  SUBSCRIPTION = 'subscription',
  TUTOR_ON_DEMAND = 'tutor_on_demand',
  USER_FEEDBACK = 'user_feedback',
  US_ONBOARDING = 'us_onboarding',
  VCC = 'video_crash_courses',
  FAMILY_ACCOUNT = 'family_account',
  REFERRAL = 'referral',
}

export enum GlobalEvents {
  LOAD_CONSENT_POPUP = 'load_consent_popup',
  COPY_TO_CLIPBOARD = 'copy-to-clipboard-via-button',
  PAGEVIEW = 'GApageview',
}
export enum Labels {
  SUCCESSFUL = 'successful',
  UNSUCCESSFUL = 'unsuccessful',
  CORRECT = 'correct',
  INCORRECT = 'incorrect',
  OPEN = 'open',
  CLOSE = 'close',
}

export enum GenericEventValues {
  HIGH = 100,
  MEDIUM = 50,
  LOW = 10,
}

export enum TrafficType {
  internal = 'internal',
  external = 'external',
}

export enum ChatEvents {
  OPEN_CHAT_PANEL = 'open_chat_panel',
  CLOSE_CHAT_PANEL = 'close_chat_panel',
}

export enum ConsentCategories {
  Statistical = 'cookie_cat_statistic',
  Marketing = 'cookie_cat_marketing',
  Functional = 'cookie_cat_functional',
  Necessary = 'cookie_cat_necessary',
  Unclassified = 'cookie_cat_unclassified',
}

export interface ITrackingBQSchema {
  event_timestamp: number
  event_name: string
  event_params: Array<Record<string, string>>
  user_id?: number
  visitor_id: string
  session_id: number
  subscription_status?: string
  traffic_source?: Record<string, string>
  platform?: string
  page_location?: string
  page_referrer?: string
  geo?: {
    country: string
    city: string
  }
}

export enum TrackingPlatform {
  WEB = 'web',
}
